export * from './StrapiFeaturedCategoriesWidget'
